export default "__VITE_ASSET__B1XxXb0y__"